import React, { useState } from "react";
import "./index.css";
import {
  Button,
  Modal,
  Typography,
  Form,
  Input,
  Select,
  InputNumber,
  Divider,
  Row,
  Col,
  TimePicker,
  DatePicker,
  Table,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
const { Title, Paragraph, Text } = Typography;
const { TextArea } = Input;
const { Option } = Select;

function DashboardForm() {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleOk = () => {
    form.submit();
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
    },
    {
      title: "Date",
      dataIndex: "datePicker",
    },
    {
      title: "Time",
      dataIndex: "timePicker",
    },
    {
      title: "Day",
      dataIndex: "day",
    },
    {
      title: "Notes(optional)",
      dataIndex: "note",
    },
  ];
  const [data, setData] = useState([
    {
      key: "1",
      index: "1",
      datePicker: <DatePicker style={{ width: "100%" }} />,
      timePicker: <TimePicker style={{ width: "100%" }} />,
      day: "___",
      note: (
        <Row gutter={8}>
          <Col flex="auto">
            <TextArea
              rows={1}
              placeholder="Write note..."
              className="optional-text"
            />
          </Col>

          <Col>
            <DeleteOutlined
              // onClick={() => handleDeleteRow()}
              style={{ color: "red", cursor: "pointer" }}
            />
          </Col>
        </Row>
      ),
    },
  ]);

  const onFinish = (values) => {
    // console.log("Form Data Submitted:", values);
  };

  const onFinishFailed = (errorInfo) => {
    // console.log("Validation Failed:", errorInfo);
  };

  const handleAddRow = () => {
    const newRow = {
      key: (data.length + 1).toString(),
      index: (data.length + 1).toString(),
      datePicker: <DatePicker style={{ width: "100%" }} />,
      timePicker: <TimePicker style={{ width: "100%" }} />,
      day: "___",
      note: (
        <Row gutter={8}>
          <Col flex="auto">
            <TextArea
              rows={1}
              placeholder="Write note..."
              className="optional-text"
            />
          </Col>
          <Col>
            <DeleteOutlined style={{ color: "red", cursor: "pointer" }} />
          </Col>
        </Row>
      ),
    };
    setData([...data, newRow]);
  };

  return (
    <>
      <Button type="primary" onClick={showDrawer} level={2}>
        New Appointment
      </Button>

      <Modal
        title={
          <Row justify="space-between" align="middle">
            <Col>
              <Title
                level={4}
                className="primary-heading"
                style={{ fontWeight: "700", margin: 0 }}
              >
                Universal Service / Treatment Form
              </Title>
            </Col>
            <Col>
              <div className="applicable-btn">Applicable to all services</div>
            </Col>
          </Row>
        }
        onOk={handleOk}
        onCancel={handleAddRow}
        open={open}
        width={"80%"}
        cancelText="+ Add 1 Session"
        okText="Submit Form"
        closable={false}
        // okButtonProps={{ htmlType: "submit" }}
        style={{ top: 20 }}
      >
        <Divider />
        <Form
          form={form}
          name="Dashboard-Form"
          requiredMark={false}
          className="DashboardForm"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          size="large"
        >
          {/* Patient Information */}
          <Title level={5} className="secondary-heading">
            Patient Information
          </Title>

          {/* Full Name + Contact */}
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Full Name"
                name="full-name"
                rules={[{ required: true, message: "Please enter your name!" }]}
              >
                <Input placeholder="Enter full name" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Father Name"
                name="father-name"
                rules={[{ required: true, message: "Please enter your name!" }]}
              >
                <Input placeholder="Enter father name" />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Contact"
                name="contact"
                rules={[{ required: true, message: "Please enter your name!" }]}
              >
                <Input placeholder="Phone / WhatsApp / Email" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="CNIC - Passport No"
                name="contact"
                // rules={[{ required: true, message: "Please enter cnic name!" }]}
              >
                <Input placeholder="cnic" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="City / Address"
                name="city-address"
                rules={[
                  { required: true, message: "Please enter city / address!" },
                ]}
              >
                <Input placeholder="City / Address" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Occupation"
                name="occupation"
                rules={[
                  { required: true, message: "Please enter occupation!" },
                ]}
              >
                <Input placeholder="Occupation" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label="Source of information"
                name="source-of-information"
                rules={[
                  {
                    required: true,
                    message: "Please enter source of information!",
                  },
                ]}
              >
                <Input placeholder="Source of informationß" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item label="Gender" name="gender">
                <Select defaultValue="...Select">
                  <Option value="male">Male</Option>
                  <Option value="female">Female</Option>
                  <Option value="others">Others</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item label="Age" name="age">
                <InputNumber
                  min={1}
                  max={100}
                  placeholder="e.g. 32"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Medical History */}
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                label="Medical History (if any)"
                name="medical-history"
                required
              >
                <Input.TextArea
                  rows={8}
                  placeholder="Allergies, medication, etc."
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Service / Treatment */}
          <Title level={5} className="secondary-heading">
            Service / Treatment
          </Title>

          <Row gutter={[16, 16]}>
            <Col xs={24} sm={10}>
              <Form.Item label="Service" name="service">
                <Select defaultValue="Select a Service">
                  <Option value="fue">FUE Hair Transplant</Option>
                  <Option value="prp">PRP Treatment</Option>
                  <Option value="laser">Laser Treatment</Option>
                  <Option value="medication">Medication / Consultation</Option>
                  <Option value="other">Other</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={14}>
              <Form.Item label="Number of Sessions" name="sessions">
                <InputNumber
                  min={1}
                  max={100}
                  placeholder="e.g. 3"
                  style={{ width: "100%" }}
                />
                <Paragraph className="description-text">
                  Set how many sessions are planned. Fields below will
                  auto-generate.
                </Paragraph>
              </Form.Item>
            </Col>
          </Row>

          <Title level={5} className="secondary-heading">
            Session Scheduling
          </Title>

          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            bordered
          />

          <Paragraph className="discription-text">
            Pick a date for each session; "Day" fills automatically.
          </Paragraph>

          <Title level={5} className="secondary-heading">
            Payment (Universal)
          </Title>

          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                label="Total Estimated Cost"
                name="estimatedCost"
                layout="vertical"
              >
                <InputNumber
                  min={1}
                  max={1000000}
                  placeholder="e.g. 75000"
                  style={{ width: "100%", borderRadius: "8px" }}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="Advance Payment"
                name="advancePayment"
                layout="vertical"
              >
                <InputNumber
                  min={1}
                  max={1000000}
                  placeholder="e.g. 20000"
                  style={{ width: "100%", borderRadius: "8px" }}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="Remaining Balance"
                name="remainingBalance"
                layout="vertical"
              >
                <InputNumber
                  min={1}
                  max={1000000}
                  placeholder="Auto/Manual"
                  style={{ width: "100%", borderRadius: "8px" }}
                />
                <Paragraph
                  className="discription-text"
                  style={{ marginTop: "4px" }}
                >
                  You can leave blank and fill later.
                </Paragraph>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Text>Admin / Doctor Notes</Text>
              <TextArea
                placeholder="Important Instructions or remarks..."
                rows={4}
              />
              <Divider />
            </Col>
          </Row>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="submit-btn">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export { DashboardForm };
